import { useEffect } from 'react';

interface HelmetProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
}

export default function Helmet({
  title = '妈妈的朋友们 - 温情故事与情感共鸣 | 母辈女性友情感悟分享',
  description = '妈妈的朋友们是一个温暖真实的情感故事平台，聚焦妈妈与闺蜜间的深厚情谊、生活哲学与人生智慧。在这里，发现母辈女性友情的动人故事，感受岁月沉淀下的情感共鸣与生命力量。',
  keywords = '妈妈的朋友们,妈妈的朋友们故事,妈妈与闺蜜的情谊,母辈女性友情,妈妈的生活圈,中年女性情感共鸣,妈妈的故事分享',
  canonicalUrl = 'https://momfriends.cn/',
  ogTitle = '妈妈的朋友们 - 温情故事与情感共鸣',
  ogDescription = '妈妈的朋友们是一个温暖真实的情感故事平台，聚焦妈妈与闺蜜间的深厚情谊、生活哲学与人生智慧。',
  ogType = 'website',
}: HelmetProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', canonicalUrl);
    }

    setMeta('og:title', ogTitle, true);
    setMeta('og:description', ogDescription, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', canonicalUrl, true);

    setMeta('twitter:title', ogTitle);
    setMeta('twitter:description', ogDescription);
  }, [title, description, keywords, canonicalUrl, ogTitle, ogDescription, ogType]);

  return null;
}